export const MODULE_NAMES = {
  PRE_ORDER: 'preorder',
  SIGN_UP: 'signup'
};
